const ClickableSpan = (props: any) => (<span role="button" tabIndex={0} {...props} />);

export default ClickableSpan;
